import { render, staticRenderFns } from "./tc-editor.vue?vue&type=template&id=3e8b276c&"
import script from "./tc-editor.vue?vue&type=script&lang=js&"
export * from "./tc-editor.vue?vue&type=script&lang=js&"
import style0 from "./tc-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports